import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import QuotesList from './quotes/QuotesList';
import { loadCategories, loadQuotesByCategory } from '../utils/quotes/loadQuotes';
import { Quote } from '../types';

export default function QuotesByCategory() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [quotes, setQuotes] = useState<Quote[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function init() {
      const cats = await loadCategories();
      setCategories(cats);
      if (cats.length > 0) {
        setSelectedCategory(cats[0].id);
      }
    }
    init();
  }, []);

  useEffect(() => {
    async function loadQuotes() {
      if (selectedCategory) {
        setLoading(true);
        const newQuotes = await loadQuotesByCategory(selectedCategory);
        setQuotes(newQuotes);
        setLoading(false);
      }
    }
    loadQuotes();
  }, [selectedCategory]);

  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Nepali Wisdom</h2>
          <p className="text-gray-600 mt-2">Explore quotes by category</p>
        </div>

        <div className="flex flex-wrap gap-2 justify-center mb-8">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 py-2 rounded-full transition-colors ${
                selectedCategory === category.id
                  ? 'bg-purple-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
              className="w-8 h-8 border-2 border-purple-600 border-t-transparent rounded-full"
            />
          </div>
        ) : (
          <QuotesList quotes={quotes} />
        )}
      </div>
    </section>
  );
}